import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const accepted = sessionStorage.getItem("ilk_accepted_terms") === "true";

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const res = await api.post("/auth/session", {
          session_id: sessionId,
          accepted_terms: accepted,
        });
        setUser(res.data);
        window.history.replaceState(null, "", "/");
        navigate("/", { state: { user: res.data }, replace: true });
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-2 border-teal-400 border-t-transparent rounded-full animate-spin" />
        <p className="font-mono text-sm text-zinc-400 uppercase tracking-[0.2em]">Authenticating…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
